<script setup>
import AppToast from "../components/ui-components/neo-layout/AppToast.vue";
import ConfirmDialog from "primevue/confirmdialog";
import {watch} from "vue";
import {Head, usePage} from "@inertiajs/vue3";
import {useToast} from "primevue/usetoast";
import {useConfirm} from "primevue/useconfirm";

const toast = useToast();
const confirm = useConfirm();

watch(() => usePage()?.props?.notification, (now) => {
    if (!now?.message) return

    if (now.variant === 'error') {
        confirm.require({
            group: 'hard-stop-dialog',
            header: now.header || 'Nelze provést',
            message: now.message,
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'OK',
            rejectProps: { style: { display: 'none' } },
            accept: () => {},
        })
        return
    }

    toast.add({
        severity: now.variant,
        summary: now.header || 'Roori',
        detail: now.message,
        life: 2000,
    })
})
</script>

<template>
    <ConfirmDialog group="hard-stop-dialog"></ConfirmDialog>
    <AppToast/>
    <Head :title="$page.props?.title"></Head>
    <slot></slot>
</template>

<style scoped lang="scss">

</style>
